import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sm-alert',
  templateUrl: './sm-alert.component.html',
  styleUrls: ['./sm-alert.component.scss']
})
export class SmAlertComponent {
  @Input() type = '';
  @Input() customIcon = null;
  @Input() style = null;
  @Input() noIcon = false;

  getAlertIcon() {
    if (this.type) {
      switch (this.type.toUpperCase()) {
        case 'SUCCESS':
          return 'checkmark-circle-fill';
        case 'INFO':
          return 'information-fill';
        case 'DANGER':
          return 'error-fill';
        case 'WARNING':
          return 'warning-fill';
        default:
          break;
      }
    }
  }
}
